import React, { useState, useEffect, useCallback } from "react";
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, Button, NavbarToggler, Collapse } from "reactstrap";
import { FaUser, FaUsers, FaClipboardList, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";

function AdminNavbar() {
  const navigate = useNavigate();
  const { url, infoTkn } = useDataContext();
  const [isOpen, setIsOpen] = useState(false);
  const [admin, setAdmin] = useState(null);

  // Obtener la información del admin
  const fetchAdminData = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Auth/findByJWTAdmin/${infoTkn}`, {
        headers: { Authorization: `Bearer ${infoTkn}` },
      });

      setAdmin(response.data.data);
    } catch (error) {
      console.error("Error obteniendo datos del administrador:", error);
    }
  }, [url, infoTkn]);

  useEffect(() => {
    fetchAdminData();
  }, [fetchAdminData]);

  const handleLogout = async () => {
    await axios.get(`${url}/Auth/logoutAdmin/${admin.adm_email}`);
    navigate("/");
  };

  return (
    <Navbar dark expand="md" className="admin-navbar px-4">
      {/* Logo del administrador */}
      <NavbarBrand href="/userportal" className="admin-navbar__logo">
        {admin?.adm_logo ? (
          <img 
            src={`${url}/Admin/logo/${admin.adm_id}`} 
            alt="Admin Logo" 
            className="admin-logo"
          />
        ) : (
          "Admin Panel" // Si no hay logo, mostrar este texto
        )}
      </NavbarBrand>

      {/* Botón de hamburguesa */}
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

      <Collapse isOpen={isOpen} navbar>
        <Nav className="admin-navbar__menu mx-auto" navbar>
          <NavItem className="admin-navbar__item">
            <NavLink href="/userportal">
              <FaUser className="admin-navbar__icon" /> Portal
            </NavLink>
          </NavItem>
          <NavItem className="admin-navbar__item">
            <NavLink href="/gestionusuarios">
              <FaUsers className="admin-navbar__icon" /> Usuarios
            </NavLink>
          </NavItem>
          <NavItem className="admin-navbar__item">
            <NavLink href="/createorder">
              <FaClipboardList className="admin-navbar__icon" /> Órdenes
            </NavLink>
          </NavItem>
          <NavItem className="admin-navbar__item">
            <NavLink href="/profile">
              <FaUser className="admin-navbar__icon" /> Perfil
            </NavLink>
          </NavItem>

          {/* Cerrar sesión SOLO en menú hamburguesa */}
          <NavItem className="admin-navbar__logout-mobile">
            <Button className="admin-navbar__logout" onClick={handleLogout}>
              <FaSignOutAlt className="admin-navbar__icon" /> Cerrar Sesión
            </Button>
          </NavItem>
        </Nav>
      </Collapse>

      {/* Cerrar sesión SOLO en escritorio */}
      <div className="admin-navbar__logout-desktop">
        <Button className="admin-navbar__logout" onClick={handleLogout}>
          <FaSignOutAlt className="admin-navbar__icon" /> Cerrar Sesión
        </Button>
      </div>
    </Navbar>
  );
}

export default AdminNavbar;
